import StudyplanEmail from './studyplan-email'
import StudyplanList from './studyplan-list'
import StudyplanApply from './studyplan-apply'

export default {
  StudyplanEmail, StudyplanList, StudyplanApply
}